import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Collapse } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import Terms from 'Components/Vouchers/Terms';

import 'Components/Vouchers/VoucherBox.scss';

const VoucherDeliveryBox = ({ delivery, accountVoucher }) => {
  const [collapse, setCollapse] = useState(false);

  return (
    <article className={classNames('voucher-box voucher-delivery-box', { 'account-voucher': accountVoucher })}>
      <div className="voucher-name">
        {delivery.description}
      </div>
      <div className="voucher-body">
        <div className="voucher-code">
          <FormattedMessage id="voucher-delivery-box.code" defaultMessage="Make a qualifying purchase and this voucher will be emailed to you" />
        </div>

        <div className="button-container">
          <div className="voucher-terms-btn">
            <Button color="link" size="sm" onClick={() => { setCollapse(!collapse); }}>
              <FormattedMessage id="voucher-delivery-box.terms-conditions" defaultMessage="Terms and Conditions" />
            </Button>
          </div>
        </div>
      </div>

      <Collapse isOpen={collapse}>
        <div className="voucher-terms">
          <h6><FormattedMessage id="voucher-box.terms-delivery" defaultMessage="Coupon Qualification Terms and Conditions" /></h6>
          <div><FormattedMessage id="voucher-box.terms-delivery-p" defaultMessage="To receive this coupon make an order that meets these conditions:" /></div>
          <div className="voucher-terms">
            <Terms isDelivery voucher={delivery} />
          </div>
          <br />
          <h6><FormattedMessage id="voucher-box.terms" defaultMessage="Coupon Terms and Conditions" /></h6>
          <Terms voucher={delivery.did} />
        </div>
      </Collapse>
    </article>
  );
};

VoucherDeliveryBox.propTypes = {
  delivery: PropTypes.shape({}),
  accountVoucher: PropTypes.bool,
};

VoucherDeliveryBox.defaultProps = {
  delivery: {},
  accountVoucher: false,
};

export default VoucherDeliveryBox;
